<template>

	<div :class="'question ' + theme">

		<h1>{{ question.text }}</h1>
		<div class="minHeight text">{{ question.subText }}</div>

		<!-- This is a multiple choice question -->
		<div class="multipleChoiceQuestion" v-if="question.questionType == 4">
			<div v-for="a in question.possibleAnswers" :key="a.id">
				<div v-if="!answersHaveIcons" :class="'multipleChoiceListAnswer ' + (a.selected ? 'selected' : '')"  @click="onAnswerSelected(a)">
					<v-row class="answerRow">
						<v-col cols="1" class="radioCol">
							<img class="radio" v-if="a.selected" :src="require('@/assets/filledRadio.png')" />
							<img class="radio" v-if="!a.selected" :src="require('@/assets/emptyRadio.png')" />
						</v-col>
						<v-col class="answerTextCol"><span class="answerText">{{ a.answer.text }}</span></v-col>
						<v-col cols="1"><span class="tick" v-if="a.selected"><v-icon icon="mdi-check" /></span></v-col>
					</v-row>
					
				</div>
				<div v-else :class="'multipleChoiceGridAnswer ' + (a.selected ? 'selected ' : '') + (question.possibleAnswers.length > 4 ? 'smallGrid' : 'bigGrid')"  @click="onAnswerSelected(a)">
					<v-row class="imgRow">
						<v-col><img :src="require('@/assets/' + a.answer.icon)" /></v-col>
					</v-row>
					<v-row>
						<v-col>{{ a.answer.text }}</v-col>
					</v-row>
				</div>
			</div>
			<div style="clear: both;"></div>
		</div>

		<!-- Number slider -->
		<div class="amountSliderQuestion" v-if="question.questionType == 1">
			<div class="center">
				<div class="amount">{{ selectedSliderAmount }}</div>
				<span v-if="question.outOf" class="outOf">out of {{ question.maxAmount }}</span>
			</div>
			<v-slider
				v-model="selectedSliderAmount" 
				:min="question.minAmount"
				:max="question.maxAmount"
				show-ticks="always"
				step="1"
				tick-size="4"
				thumb-label="false"
				class="slider mt-5"
			></v-slider>
			<div class="tickLabels">
				<span>{{ question.minLabel }}</span><span>{{ question.maxLabel }}</span>
			</div>
		</div>

		<!-- Money slider -->
		<div class="moneySliderQuestion" v-if="question.questionType == 2">
			<span class="amount">{{ formatter.format(selectedSliderAmount) }}</span>
			<v-slider
				v-model="selectedSliderAmount" 
				:min="minAmount"
				:max="maxAmount"
				:step="stepAmount"
				tick-size="4"
				thumb-label="false"
				class="slider mt-5"
			></v-slider>
		</div>

		<!-- Text input -->
		<div class="textInputQuestion" v-if="question.questionType == 0">
			<v-text-field v-model="selectedTextInputAmount" @update:model-value="onTextInputAnswerSelected" />
		</div>

		<div class="text mt-9 onlyTallScreen" v-if="question.description">{{ question.description }}</div>

	</div>
</template>

<script>

export default {
	name: "QuestionnaireQuestion",
	props: ['question', 'formatter', 'theme'],

	data() {
		return{
			selection: [],
			minAmount: 0,
			maxAmount: 10000,
			stepAmount: 100,
			selectedSliderAmount: 0,
			selectedTextInputAmount: null
		}
	},

	computed: {
		answersHaveIcons() {
			if (!this.question || !this.question.possibleAnswers) { return false; }
			return this.question.possibleAnswers.some(a => a.answer.icon);
		}
    },

	watch:{
		'selectedSliderAmount'  : function() {
			this.onSliderAnswerSelected();
		}
	},

	methods: {

		onLoad() {
			if (this.question.questionType == 1){
				this.selectedSliderAmount = this.question.defaultAmount;
			}
			if (this.question.selectedAnswer && [1, 2].includes(this.question.questionType)) {
				if (Array.isArray(this.question.selectedAnswer)){
					this.selectedSliderAmount = this.question.selectedAnswer[0].amount;
				} else {
					this.selectedSliderAmount = this.question.selectedAnswer;
				}
			}
			if (this.question.questionType == 0) {
				this.selectedTextInputAmount = this.question.selectedAnswer;
			}
			this.question.possibleAnswers.forEach(a => {
				if (a.selected) {
					this.selection.push(...this.question.possibleAnswers.filter(a => a.selected));
					this.$emit('answered', this.selection);
				}
			});
		},

		onSliderAnswerSelected: function() {
			if ([1, 2].includes(this.question.questionType)) {
				this.selection = [{ amount: this.selectedSliderAmount }];
				this.$emit('answered', this.selection);
			}
		},

		onTextInputAnswerSelected: function() {
			this.selection = [{ amount: this.selectedTextInputAmount }];
			this.$emit('answered', this.selection);
		},

		onAnswerSelected(answer) {
			this.selection = [];
			if (!this.question.multipleChoice) {
				this.question.possibleAnswers.forEach(a => a.selected = false);
			}
			answer.selected = !answer.selected;
			this.selection.push(...this.question.possibleAnswers.filter(a => a.selected));
			this.$emit('answered', this.selection);
		}

	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

	h1{
		font-size: 24px;
	}

	.light h1 {
		text-align: center;
		font-size: 16px;
	}

	.question {
		margin-top: 15px;
	}

	.question.light {
		color: var(--text-color);
	}

	.text {
		font-size: 15px;
	}

	.minHeight{
		min-height: 22px;
	}

	.tickLabels{
		margin-left: -15px;
		margin-right: -15px;
		margin-top: -30px;
		font-size: 12px;
		text-align: left;
		span:last-child{
			float: right;
		}
	}

	.multipleChoiceQuestion {
		max-height: 63vh;
		overflow-y: scroll;
		overflow-x: hidden;
	}

	.multipleChoiceListAnswer {
		margin-top: 15px;
		background-color: #ffffff13;
		padding: 20px;
		border-radius: 8px;
		font-size: 15px;
		answerTextCol {
			text-align: left;
		}
		.answerText {
			display: block;
			float: left;
			margin-left: 4px;
			p--adding-bottom: 17px;
		}
		.light .answerText {
			font-size: 14px;
		}
	}

	.light .multipleChoiceListAnswer .answerText {
		font-size: 14px;
		w--hite-space: nowrap;
	}

	.light .answerTextCol {
		margin-top: auto;
		margin-bottom: auto;
	}

	.answerRow .v-col{

	}

	.light .answerRow .v-col{
		padding-top: 13px;
	}

	.radioCol {
		display: none;
	}

	.light .multipleChoiceListAnswer {
		background-color: var(--background-color-alt);
		border-radius: 10px;
		h--eight: 48px;
		padding: 10px;
	}

	.selected {
		background: linear-gradient(211.44deg, #EEF0FF 17.53%, #D4D9F2 84.89%);
		color: var(--text-color);
	}

	.light .selected {
		background: linear-gradient(211.44deg, #EEF0FF 17.53%, #D4D9F2 84.89%);
	}

	.light .radioCol {
		display: unset;
		margin-top: auto;
		margin-bottom: auto;
	}

	.radioCol img{
		margin-top: 6px;
		height:18px;
	}

	.tick {
		text-align: right;
		float: right;
	}

	.light .tick {
		display: none;
	}

	.amount {
		font-size: 30px;
		margin-top: 20px;
	}

	.slider {
		margin-top: 20px;
		color: white;
	}

	.moneySliderQuestion, .amountSliderQuestion {
		margin-top: 60px;
	}

	.amountSliderQuestion{
		text-align: center;
		.amount {
			font-size: 120px;
			line-height: 100%;
		}
		.outOf{
			font-size: 14px;
		}
	}

	.multipleChoiceGridAnswer {
		background-color: #ffffff13;
		float: left;
		padding: 15px;
		width: calc((100vw - (60px + (8px * 4))) / 2);
		height: 200px;
		border-radius: 4px;
		margin-right: 8px;
		margin-left: 8px;
		margin-top: 16px;
		.imgRow {
			text-align: center;
			padding-top: 7px; 
		}
		img {
			height: 64px;
			border-radius: 100%;
		}
		font-size: 15px;
	}

	.bigGrid {
	}	

	.smallGrid {
		font-size: 13px;
		padding: 15px;
		height: 100px;
		img {
			height: 32px;
		}
		.imgRow {
			text-align: left;
			padding-top: 10px;
		}
		.v-col {
			padding-top: 0px;
			padding-bottom: 0px;
		}
	}	

	.light :deep(.v-slider-track__fill) {
		background:linear-gradient(215.75deg, #9EA2D0 3.1%, #61678D 95.08%) !important;
	}

	@media(max-height: 670px) {
		.multipleChoiceQuestion {
			padding-bottom: 100px;
		}
	}
	

	
</style>